<template>
  <div>
    <!-- <div class="mainTitle">教师管理</div> -->

    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="5">
            <el-form-item label="手机号码" prop="mobile">
              <el-input
                v-model="searchForm.mobile"
                placeholder="请输入手机号码"
                auto-complete="off"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="5">
            <el-form-item label="教师姓名" prop="name">
              <el-input
                v-model="searchForm.name"
                placeholder="请输入教师姓名"
                auto-complete="off"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="5">
            <el-form-item label="所属机构" prop="sourceType">
              <el-select style="width:100%" v-model="searchForm.agentId" clearable>
                <el-option v-for="i in organizations" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :sm="24" :md="12" :lg="6">
            <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-col>-->
          <el-col style="float:right" :sm="24" :md="24" :lg="9">
            <div class="button-Arrays" style="float:right">
              <el-button
                type="primary"
                style="border-top-left-radius:3px !important;border-bottom-left-radius:3px !important;"
                @click="page.pageNumber=1,pageList()"
                icon="el-icon-search"
              >查询</el-button>
              <el-button
                type="primary"
                style="background:rgb(24,200,168);border-color:rgb(24,200,168)"
                icon="el-icon-refresh"
                @click="reset"
              >重置</el-button>
              <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
              <!-- <el-button
                type="primary"
                @click="importFormVisible = true"
                style="background:rgb(251,149,82);border-color:rgb(251,149,82)"
                icon="el-icon-download"
              >导入</el-button>
              <el-button
                style="text-align: right"
                type="primary"
                @click="exportExcel"
                :loading="loading"
                icon="el-icon-upload2"
              >导出</el-button>-->
              <el-button
                type="danger"
                style="border-top-left-radius:0px !important;border-bottom-left-radius:0px !important;"
                @click="batchDeleteTeacher"
                icon="el-icon-minus"
              >批量删除</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <!-- <el-col :span="12">
          <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
          <el-button type="danger" @click="batchDeleteTeacher" icon="el-icon-minus">批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
          >导出</el-button>
        </el-col>-->
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        v-loading="teacherLoading"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.sync==1">启用</span>
            <span v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="教师ID"></el-table-column>
        <el-table-column prop="name" show-overflow-tooltip label="教师姓名">
          <template slot-scope="scope">
            <div class="list-name-img">
              <img :src="scope.row.headPic?scope.row.headPic:defaultImg" alt="教师头像" />
              <div v-if="scope.row.name">{{scope.row.name}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号码"></el-table-column>
        <el-table-column prop="summary" show-overflow-tooltip label="教师简介"></el-table-column>
        <el-table-column prop="detail" show-overflow-tooltip label="详细信息"></el-table-column>
        <el-table-column prop label="操作" width="100" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <i
                class="iconfont iconbianji mainColor"
                title="编辑"
                @click="selection = scope.row.id, editFormVisible = true"
              ></i>
              <i
                class="iconfont iconshanchu mainColor"
                title="删除"
                @click="deleteTeacher(scope.row)"
              ></i>
              <!-- <span style="width:50%" @click="selection = scope.row.id, editFormVisible = true">编辑</span>

              <span style="width:50%" @click="deleteTeacher(scope.row)">删除</span>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="添加老师" :visible.sync="addFormVisible" width="50%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="教师ID" prop="number">
            <el-input
              v-model="addForm.number"
              placeholder="请输入教师ID"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="手机号码" prop="mobile">
            <el-input
              v-model="addForm.mobile"
              placeholder="请输入手机号码"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="教师姓名" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入教师姓名"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="显示排序" prop="sort">
            <el-input
              type="number"
              v-model="addForm.sort"
              placeholder="请输入显示排序"
              auto-complete="off"
              maxlength="10"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="教师简介" prop="summary">
            <el-input
              type="textarea"
              :rows="3"
              v-model="addForm.summary"
              placeholder="请输入教师简介"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="详细信息" prop="detail">
            <el-input
              type="textarea"
              :rows="3"
              v-model="addForm.detail"
              placeholder="请输入详细信息"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="教师头像" prop="headPic">
            <div class="upload-div">
              <img class="upload-img" :src="addForm.headPic?addForm.headPic:defaultImg" alt />
              <div class="upload-content">
                <div>
                  <el-upload
                    class="crm-upload"
                    :action="fileObj.url"
                    :on-remove="handleRemove"
                    :on-change="handleChange"
                    :before-upload="beforeUpload"
                    :on-success="UploadSuccess"
                    :headers="reqData"
                    list-type="picture"
                    :show-file-list="false"
                  >
                    <div class="content-text">上传头像</div>
                  </el-upload>
                </div>
                <div class="content-texts">
                  <span class="content-texts" style="font-size:10px">支持JPG、PNG、GIF格式，小于2M</span>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="是否启用" prop="state">
            <el-radio-group v-model="addForm.state">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="-1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTeacher">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑老师" :visible.sync="editFormVisible" width="50%" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="教师ID" prop="number">
            <el-input
              v-model="editForm.number"
              placeholder="请输入教师ID"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="手机号码" prop="mobile">
            <el-input
              v-model="editForm.mobile"
              placeholder="请输入手机号码"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="教师姓名" prop="name">
            <el-input
              v-model="editForm.name"
              placeholder="请输入教师姓名"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="显示排序" prop="sort">
            <el-input
              type="number"
              v-model="editForm.sort"
              placeholder="请输入显示排序"
              auto-complete="off"
              maxlength="10"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="教师简介" prop="summary">
            <el-input
              type="textarea"
              :rows="3"
              v-model="editForm.summary"
              placeholder="请输入教师简介"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="详细信息" prop="detail">
            <el-input
              type="textarea"
              :rows="3"
              v-model="editForm.detail"
              placeholder="请输入详细信息"
              auto-complete="off"
              maxlength="255"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="教师头像" prop="headPic">
            <div class="upload-div">
              <img class="upload-img" :src="editForm.headPic?editForm.headPic:defaultImg" alt />
              <div class="upload-content">
                <div>
                  <el-upload
                    class="crm-upload"
                    :action="fileObj.url"
                    :on-remove="handleRemove"
                    :on-change="handleChange"
                    :before-upload="beforeUpload"
                    :on-success="UploadSuccess"
                    :headers="reqData"
                    list-type="picture"
                    :show-file-list="false"
                  >
                    <div class="content-text">上传头像</div>
                  </el-upload>
                </div>
                <div class="content-texts">
                  <span class="content-texts" style="font-size:10px">支持JPG、PNG、GIF格式，小于2M</span>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="是否启用" prop="state">
            <el-radio-group v-model="editForm.state">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="-1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateTeacher">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :headers="reqData"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.sync==1">启用</span>
            <span v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="教师ID"></el-table-column>
        <el-table-column prop="name" label="教师姓名"></el-table-column>
        <el-table-column prop="mobile" label="手机号码"></el-table-column>
        <el-table-column prop="summary" label="教师简介"></el-table-column>
        <el-table-column prop="detail" label="详细信息"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultImg: "../../../static/image/defaultImg.png",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "create_time",
        sortOrder: "desc"
      },
      organizations: [],

      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      teacherLoading: false,
      searchForm: {
        mobile: "",
        name: ""
      },
      addForm: {
        number: "",
        mobile: "",
        name: "",
        sort: "",
        headPic: "",
        state: 1,
        summary: "",
        detail: ""
      },
      addFormRules: {
        number: [
          {
            required: true,
            message: "请输入教师ID",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "教师ID长度在1到255个字"
          }
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字"
          },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入教师姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "教师姓名长度在1到255个字"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        headPic: [
          {
            required: true,
            message: "请输入教师头像",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "教师头像长度在1到255个字"
          }
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确"
          }
        ],
        summary: [
          {
            required: true,
            message: "请输入简介",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "简介长度在1到255个字"
          }
        ],
        detail: [
          {
            required: true,
            message: "请输入详细信息",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "详细信息长度在1到255个字"
          }
        ]
      },
      editForm: {
        number: "",
        mobile: "",
        name: "",
        sort: "",
        headPic: "",
        state: "",
        summary: "",
        detail: ""
      },
      editFormRules: {
        number: [
          {
            required: true,
            message: "请输入教师ID",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "教师ID长度在1到255个字"
          }
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字"
          },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入教师姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "教师姓名长度在1到255个字"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        headPic: [
          {
            required: true,
            message: "请输入教师头像",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "教师头像长度在1到255个字"
          }
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确"
          }
        ],
        summary: [
          {
            required: true,
            message: "请输入简介",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "简介长度在1到255个字"
          }
        ],
        detail: [
          {
            required: true,
            message: "请输入详细信息",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "详细信息长度在1到255个字"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/teacher/upload`,
      fileList: [],
      loading: false
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    UploadSuccess(res, file, fileList, val) {
      console.log(res.data);
      if (this.editFormVisible) {
        this.editForm.headPic = res.data;
      } else if (this.addFormVisible) {
        this.addForm.headPic = res.data;
      }
      // this.picUrl.push({
      //   name: res.data[0].FileName,
      //   url: res.data[0].FilePath
      // });
    },
    getAgentInfoList() {
      this.api.agentUserInfo.getAgentInfoList().then(result => {
        this.organizations = result.data;
      });
    },
    handleRemove(file, fileList) {
      // this.uploadList = fileList;
      // if (this.picUrl.length > 0) {
      //   for (let i = 0; i < this.picUrl.length; i++) {
      //     if (this.picUrl[i].uid == file.uid) {
      //       this.picUrl.splice(i, 1);
      //     }
      //   }
      // }
    },
    handleChange(file, fileList) {
      // this.picUrl = fileList.slice(-1);
    },
    beforeUpload(file) {
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getTeacher() {
      this.api.teacher
        .getTeacher({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.teacherLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.teacher
        .teacherPageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.teacherLoading = false;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addTeacher() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.teacher
            .addTeacher(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateTeacher() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.teacher
            .updateTeacher(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteTeacher(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.teacher
            .deleteTeacher([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteTeacher() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.teacher
            .deleteTeacher(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.teacher
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.teacher
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    user: function() {
      console.log(111111, this.user);
    },
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getTeacher();
      }
    }
  },
  mounted() {
    console.log(111111, this.user);
    this.getAgentInfoList();
    this.pageList();
  }
};
</script>

<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}
.upload-div {
  display: flex;
  flex-direction: row;
  .upload-img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px solid rgb(238, 238, 238);
  }
  .upload-content {
    margin-left: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content-text {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
    }
    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/teacher/index.vue